import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectOption, Typography, Delimiter } from '@otp/ui';
import { Trash } from '@otp/icons';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import clsx from 'clsx';
import { SelectedRole } from 'src/components/login-rules/form/types';
import { Link } from 'src/components/common/link';
import { Routes } from 'src/components/common/router/constants';

type RoleDropdownProps = {
  options: SelectOption[];
  selectedItems: SelectedRole[];
  onAddItem: (item: SelectedRole) => void;
  onRemoveItem: (item: SelectedRole) => void;
  listName: string;
  listNameClass?: string;
};

export const RoleDropdown = ({
  options,
  selectedItems,
  onAddItem,
  onRemoveItem,
  listName,
  listNameClass,
}: RoleDropdownProps) => {
  const { t } = useTranslation();

  const onChange = (event: SelectChangeEvent<any>) => {
    const id = event.target.value;

    const selectedOption = options.find((option) => option.value === id);
    if (!selectedOption) {
      return;
    }

    onAddItem({
      id: selectedOption.value,
      name: selectedOption.name,
    });
  };

  return (
    <>
      <Select fullWidth={true} options={options} onChange={onChange} value="" />

      <div
        className={clsx(
          'flex flex-row justify-between w-full rounded-t-md py-2 mt-4',
          listNameClass,
        )}
      >
        <Typography
          color="primary.10"
          fontWeight="bold"
          variant="subtitle1"
          className="pl-2"
        >
          {listName}
        </Typography>
        <Typography
          fontWeight="bold"
          variant="subtitle1"
          className="pr-2"
          color="primary.40"
        >
          {t('login-rules.form.permission-role.actions')}
        </Typography>
      </div>

      <div className="flex flex-col py-1">
        {selectedItems.map((item: SelectedRole) => (
          <div key={item.id}>
            <Typography
              className="flex flex-row justify-between pl-2 h-10 text-md items-center"
              variant="subtitle1"
            >
              <Link to={`${Routes.roles.path}/${item.id}`} target="_blank">
                <span className="underline">{item.name}</span>
              </Link>

              <Trash
                onClick={() => onRemoveItem(item)}
                className="cursor-pointer mr-2"
              />
            </Typography>
            <Delimiter />
          </div>
        ))}
      </div>
    </>
  );
};
